import * as yup from "yup";
export interface IIncrementEmployeeCategory {
    id?: number;
    category: string;
    usePerformanceEvaluation: boolean;
    useEffortModule: boolean;
    useDisciplineModule: boolean;
    // useTeamMetrics: boolean;
    isActive?: boolean;
    company_Id: number;
    department_Id: number;
    general_Setting_Id: number

}
export const EmployeeCategoryDefaultValues: IIncrementEmployeeCategory = {
    id: 0,
    category: "",
    usePerformanceEvaluation: false,
    useEffortModule: false,
    useDisciplineModule: false,
    // useTeamMetrics: false,
    isActive: true,
    company_Id: 0,
    department_Id: 0,
    general_Setting_Id: 0
};
export const incrementEmployeeCategorySchema = yup.object().shape({
    id: yup.number().optional(),
    category: yup.string().required("Category is required").max(200, "Category cannot exceed 200 characters"),
    businessProcess: yup
    .number()
    .transform((value, originalValue) => originalValue === "" ? undefined : value )
    .typeError("Company is required")
    .required("Company is required")
    .moreThan(0, "Please select a company"),

  department_Id: yup
    .number()
    .transform((value, originalValue) => originalValue === "" ? undefined : value )
    .typeError("Department is required")
    .required("Department is required")
    .moreThan(0, "Please select a department"),
    usePerformanceEvaluation: yup.boolean(),
    useEffortModule: yup.boolean(),
    useDisciplineModule: yup.boolean(),
    // useTeamMetrics: yup.boolean(),
    general_Setting_Id: yup.number().typeError("Default Cycle year required").min(1, "Default Cycle year required").required("Default Cycle year required"),

});